import React from 'react';

const SkeletonBlock = ({ className }) => <div className={`t-animate-pulse t-rounded-xl t-bg-g200 ${className}`} />;

const DashboardSkeleton = () => {
  return (
    <div className="t-flex t-flex-col t-gap-5" aria-busy="true">
      <SkeletonBlock className="t-h-10 t-w-full t-max-w-[430px]" />
      <SkeletonBlock className="t-h-[64px] t-w-full" />
      <SkeletonBlock className="t-h-[150px] t-w-full" />
      <SkeletonBlock className="t-h-[116px] t-w-full" />
      <div className="t-grid t-grid-cols-1 t-gap-5 xl:t-grid-cols-2">
        <SkeletonBlock className="t-h-[170px] t-w-full" />
        <SkeletonBlock className="t-h-[170px] t-w-full" />
      </div>
      <SkeletonBlock className="t-h-[250px] t-w-full" />
    </div>
  );
};

export default DashboardSkeleton;
